// extracted by mini-css-extract-plugin
module.exports = {"typeSelect":"typeSelect__MS3+L","typeSelectDropdownClassName":"typeSelectDropdownClassName__IHIOx"};